import {useMutation, useQueryClient} from '@tanstack/react-query';

import {addCountryCode} from '../api';
import {QUERY__COUNTRY_CODES} from '../queryKeys';

export const useAddCountryCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (countryCode: string) => addCountryCode(countryCode),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__COUNTRY_CODES]});
    },
  });
};
